import {
  FETCH_SUMMARY_PAGE_FIELDS,
  TOGGLE_EMAIL_MODAL,
  SET_BUY_URL,
  SET_SENDING_EMAIL_TEXT,
  TOGGLE_EMAIL_SENT,
} from "../actions/types";

const INITIAL_STATE = {
  pageTitleText: "",
  backButtonText: "",
  buyButtonText: "",
  priceText: "",
  redoButtonText: "",
  shareButtonText: "",
  wishListButtonText: "",
  emailModalOpen: false,
  buyURL: "",
  sendingEmailText: "",
  emailSent: false,
  emailModalTitleText: "",
  emailSentModalTitleText: "",
  emailSentModalText: "",
  emailSentModalButtonText: "",
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SUMMARY_PAGE_FIELDS:
      if (action.payload && action.payload.items) {
        return {
          ...state,
          pageTitleText: action.payload.items[0].fields.pageTitleText,
          backButtonText: action.payload.items[0].fields.backButtonText,
          buyButtonText: action.payload.items[0].fields.buyButtonText,
          priceText: action.payload.items[0].fields.priceText,
          redoButtonText: action.payload.items[0].fields.redoButtonText,
          shareButtonText: action.payload.items[0].fields.shareButtonText,
          wishListButtonText: action.payload.items[0].fields.wishListButtonText,
          emailModalTitleText:
            action.payload.items[0].fields.emailModalTitleText,
          emailSentModalTitleText:
            action.payload.items[0].fields.emailSentModalTitleText,
          emailSentModalText: action.payload.items[0].fields.emailSentModalText,
          emailSentModalButtonText:
            action.payload.items[0].fields.emailSentModalButtonText,
        };
      }
      return state;
    case TOGGLE_EMAIL_MODAL:
      return {
        ...state,
        emailModalOpen: !state.emailModalOpen,
      };
    case SET_BUY_URL:
      return {
        ...state,
        buyURL: action.payload,
      };
    case SET_SENDING_EMAIL_TEXT:
      return {
        ...state,
        sendingEmailText: action.payload,
      };
    case TOGGLE_EMAIL_SENT:
      return {
        ...state,
        emailSent: !state.emailSent,
      };
    default:
      return state;
  }
};
